import { BibleBook } from '../types/bible'

// ESV API Configuration
export const ESV_API_BASE_URL = 'https://api.esv.org/v3/passage'
export const ESV_API_KEY = import.meta.env.VITE_ESV_API_KEY || ''

// Bible Books Metadata - All 66 books
export const BIBLE_BOOKS: BibleBook[] = [
  // Old Testament (39 books)
  { id: 'gen', name: 'Genesis', abbreviation: 'Gen', testament: 'old', chapters: 50, description: 'The book of beginnings' },
  { id: 'exod', name: 'Exodus', abbreviation: 'Exod', testament: 'old', chapters: 40, description: 'The deliverance from Egypt' },
  { id: 'lev', name: 'Leviticus', abbreviation: 'Lev', testament: 'old', chapters: 27, description: 'Laws and worship' },
  { id: 'num', name: 'Numbers', abbreviation: 'Num', testament: 'old', chapters: 36, description: 'The wilderness journey' },
  { id: 'deut', name: 'Deuteronomy', abbreviation: 'Deut', testament: 'old', chapters: 34, description: 'The second law' },
  { id: 'josh', name: 'Joshua', abbreviation: 'Josh', testament: 'old', chapters: 24, description: 'Conquest of Canaan' },
  { id: 'judg', name: 'Judges', abbreviation: 'Judg', testament: 'old', chapters: 21, description: 'The judges of Israel' },
  { id: 'ruth', name: 'Ruth', abbreviation: 'Ruth', testament: 'old', chapters: 4, description: 'A story of loyalty and love' },
  { id: '1sam', name: '1 Samuel', abbreviation: '1 Sam', testament: 'old', chapters: 31, description: 'The first king of Israel' },
  { id: '2sam', name: '2 Samuel', abbreviation: '2 Sam', testament: 'old', chapters: 24, description: 'The reign of David' },
  { id: '1kgs', name: '1 Kings', abbreviation: '1 Kgs', testament: 'old', chapters: 22, description: 'The divided kingdom' },
  { id: '2kgs', name: '2 Kings', abbreviation: '2 Kgs', testament: 'old', chapters: 25, description: 'The fall of Israel and Judah' },
  { id: '1chr', name: '1 Chronicles', abbreviation: '1 Chr', testament: 'old', chapters: 29, description: 'The genealogy and history' },
  { id: '2chr', name: '2 Chronicles', abbreviation: '2 Chr', testament: 'old', chapters: 36, description: 'The history of Judah' },
  { id: 'ezra', name: 'Ezra', abbreviation: 'Ezra', testament: 'old', chapters: 10, description: 'The return from exile' },
  { id: 'neh', name: 'Nehemiah', abbreviation: 'Neh', testament: 'old', chapters: 13, description: 'Rebuilding the walls' },
  { id: 'esth', name: 'Esther', abbreviation: 'Esth', testament: 'old', chapters: 10, description: 'God\'s providence' },
  { id: 'job', name: 'Job', abbreviation: 'Job', testament: 'old', chapters: 42, description: 'Suffering and faith' },
  { id: 'ps', name: 'Psalms', abbreviation: 'Ps', testament: 'old', chapters: 150, description: 'Songs and prayers' },
  { id: 'prov', name: 'Proverbs', abbreviation: 'Prov', testament: 'old', chapters: 31, description: 'Wisdom literature' },
  { id: 'eccl', name: 'Ecclesiastes', abbreviation: 'Eccl', testament: 'old', chapters: 12, description: 'The meaning of life' },
  { id: 'song', name: 'Song of Solomon', abbreviation: 'Song', testament: 'old', chapters: 8, description: 'Love and marriage' },
  { id: 'isa', name: 'Isaiah', abbreviation: 'Isa', testament: 'old', chapters: 66, description: 'The prophet of salvation' },
  { id: 'jer', name: 'Jeremiah', abbreviation: 'Jer', testament: 'old', chapters: 52, description: 'The weeping prophet' },
  { id: 'lam', name: 'Lamentations', abbreviation: 'Lam', testament: 'old', chapters: 5, description: 'Mourning over Jerusalem' },
  { id: 'ezek', name: 'Ezekiel', abbreviation: 'Ezek', testament: 'old', chapters: 48, description: 'The prophet of visions' },
  { id: 'dan', name: 'Daniel', abbreviation: 'Dan', testament: 'old', chapters: 12, description: 'Prophetic visions and faithfulness' },
  { id: 'hos', name: 'Hosea', abbreviation: 'Hos', testament: 'old', chapters: 14, description: 'God\'s love for Israel' },
  { id: 'joel', name: 'Joel', abbreviation: 'Joel', testament: 'old', chapters: 3, description: 'The day of the Lord' },
  { id: 'amos', name: 'Amos', abbreviation: 'Amos', testament: 'old', chapters: 9, description: 'Justice and righteousness' },
  { id: 'obad', name: 'Obadiah', abbreviation: 'Obad', testament: 'old', chapters: 1, description: 'Judgment on Edom' },
  { id: 'jonah', name: 'Jonah', abbreviation: 'Jonah', testament: 'old', chapters: 4, description: 'The reluctant prophet' },
  { id: 'mic', name: 'Micah', abbreviation: 'Mic', testament: 'old', chapters: 7, description: 'Justice and mercy' },
  { id: 'nah', name: 'Nahum', abbreviation: 'Nah', testament: 'old', chapters: 3, description: 'Judgment on Nineveh' },
  { id: 'hab', name: 'Habakkuk', abbreviation: 'Hab', testament: 'old', chapters: 3, description: 'Faith in difficult times' },
  { id: 'zeph', name: 'Zephaniah', abbreviation: 'Zeph', testament: 'old', chapters: 3, description: 'The day of the Lord' },
  { id: 'hag', name: 'Haggai', abbreviation: 'Hag', testament: 'old', chapters: 2, description: 'Rebuilding the temple' },
  { id: 'zech', name: 'Zechariah', abbreviation: 'Zech', testament: 'old', chapters: 14, description: 'Messianic prophecies' },
  { id: 'mal', name: 'Malachi', abbreviation: 'Mal', testament: 'old', chapters: 4, description: 'The last Old Testament prophet' },
  
  // New Testament (27 books)
  { id: 'matt', name: 'Matthew', abbreviation: 'Matt', testament: 'new', chapters: 28, description: 'The Gospel of the King' },
  { id: 'mark', name: 'Mark', abbreviation: 'Mark', testament: 'new', chapters: 16, description: 'The Gospel of action' },
  { id: 'luke', name: 'Luke', abbreviation: 'Luke', testament: 'new', chapters: 24, description: 'The Gospel of the Son of Man' },
  { id: 'john', name: 'John', abbreviation: 'John', testament: 'new', chapters: 21, description: 'The Gospel of the Son of God' },
  { id: 'acts', name: 'Acts', abbreviation: 'Acts', testament: 'new', chapters: 28, description: 'The early church' },
  { id: 'rom', name: 'Romans', abbreviation: 'Rom', testament: 'new', chapters: 16, description: 'The gospel of grace' },
  { id: '1cor', name: '1 Corinthians', abbreviation: '1 Cor', testament: 'new', chapters: 16, description: 'Correction and instruction' },
  { id: '2cor', name: '2 Corinthians', abbreviation: '2 Cor', testament: 'new', chapters: 13, description: 'Paul\'s defense and ministry' },
  { id: 'gal', name: 'Galatians', abbreviation: 'Gal', testament: 'new', chapters: 6, description: 'Freedom in Christ' },
  { id: 'eph', name: 'Ephesians', abbreviation: 'Eph', testament: 'new', chapters: 6, description: 'The church and spiritual warfare' },
  { id: 'phil', name: 'Philippians', abbreviation: 'Phil', testament: 'new', chapters: 4, description: 'Joy in Christ' },
  { id: 'col', name: 'Colossians', abbreviation: 'Col', testament: 'new', chapters: 4, description: 'The supremacy of Christ' },
  { id: '1thess', name: '1 Thessalonians', abbreviation: '1 Thess', testament: 'new', chapters: 5, description: 'The second coming' },
  { id: '2thess', name: '2 Thessalonians', abbreviation: '2 Thess', testament: 'new', chapters: 3, description: 'The day of the Lord' },
  { id: '1tim', name: '1 Timothy', abbreviation: '1 Tim', testament: 'new', chapters: 6, description: 'Pastoral instruction' },
  { id: '2tim', name: '2 Timothy', abbreviation: '2 Tim', testament: 'new', chapters: 4, description: 'Final instructions' },
  { id: 'titus', name: 'Titus', abbreviation: 'Titus', testament: 'new', chapters: 3, description: 'Church leadership' },
  { id: 'phlm', name: 'Philemon', abbreviation: 'Phlm', testament: 'new', chapters: 1, description: 'Forgiveness and reconciliation' },
  { id: 'heb', name: 'Hebrews', abbreviation: 'Heb', testament: 'new', chapters: 13, description: 'The superiority of Christ' },
  { id: 'james', name: 'James', abbreviation: 'James', testament: 'new', chapters: 5, description: 'Faith and works' },
  { id: '1pet', name: '1 Peter', abbreviation: '1 Pet', testament: 'new', chapters: 5, description: 'Suffering and hope' },
  { id: '2pet', name: '2 Peter', abbreviation: '2 Pet', testament: 'new', chapters: 3, description: 'False teachers and the end' },
  { id: '1john', name: '1 John', abbreviation: '1 John', testament: 'new', chapters: 5, description: 'Love and truth' },
  { id: '2john', name: '2 John', abbreviation: '2 John', testament: 'new', chapters: 1, description: 'Walking in truth' },
  { id: '3john', name: '3 John', abbreviation: '3 John', testament: 'new', chapters: 1, description: 'Hospitality and truth' },
  { id: 'jude', name: 'Jude', abbreviation: 'Jude', testament: 'new', chapters: 1, description: 'Contending for the faith' },
  { id: 'rev', name: 'Revelation', abbreviation: 'Rev', testament: 'new', chapters: 22, description: 'The revelation of Jesus Christ' },
]

// Book name mappings for parsing references
export const BOOK_NAME_MAP: Record<string, string> = {
  // Full names
  'genesis': 'gen',
  'exodus': 'exod',
  'leviticus': 'lev',
  'numbers': 'num',
  'deuteronomy': 'deut',
  'joshua': 'josh',
  'judges': 'judg',
  'ruth': 'ruth',
  '1 samuel': '1sam',
  '2 samuel': '2sam',
  '1 kings': '1kgs',
  '2 kings': '2kgs',
  '1 chronicles': '1chr',
  '2 chronicles': '2chr',
  'ezra': 'ezra',
  'nehemiah': 'neh',
  'esther': 'esth',
  'job': 'job',
  'psalms': 'ps',
  'psalm': 'ps',
  'proverbs': 'prov',
  'ecclesiastes': 'eccl',
  'song of solomon': 'song',
  'song of songs': 'song',
  'isaiah': 'isa',
  'jeremiah': 'jer',
  'lamentations': 'lam',
  'ezekiel': 'ezek',
  'daniel': 'dan',
  'hosea': 'hos',
  'joel': 'joel',
  'amos': 'amos',
  'obadiah': 'obad',
  'jonah': 'jonah',
  'micah': 'mic',
  'nahum': 'nah',
  'habakkuk': 'hab',
  'zephaniah': 'zeph',
  'haggai': 'hag',
  'zechariah': 'zech',
  'malachi': 'mal',
  'matthew': 'matt',
  'mark': 'mark',
  'luke': 'luke',
  'john': 'john',
  'acts': 'acts',
  'romans': 'rom',
  '1 corinthians': '1cor',
  '2 corinthians': '2cor',
  'galatians': 'gal',
  'ephesians': 'eph',
  'philippians': 'phil',
  'colossians': 'col',
  '1 thessalonians': '1thess',
  '2 thessalonians': '2thess',
  '1 timothy': '1tim',
  '2 timothy': '2tim',
  'titus': 'titus',
  'philemon': 'phlm',
  'hebrews': 'heb',
  'james': 'james',
  '1 peter': '1pet',
  '2 peter': '2pet',
  '1 john': '1john',
  '2 john': '2john',
  '3 john': '3john',
  'jude': 'jude',
  'revelation': 'rev',
  // Abbreviations
  'gen': 'gen',
  'exod': 'exod',
  'ex': 'exod',
  'lev': 'lev',
  'num': 'num',
  'nu': 'num',
  'deut': 'deut',
  'dt': 'deut',
  'josh': 'josh',
  'judg': 'judg',
  'jg': 'judg',
  '1sam': '1sam',
  '1sa': '1sam',
  '2sam': '2sam',
  '2sa': '2sam',
  '1kgs': '1kgs',
  '1ki': '1kgs',
  '2kgs': '2kgs',
  '2ki': '2kgs',
  '1chr': '1chr',
  '1ch': '1chr',
  '2chr': '2chr',
  '2ch': '2chr',
  'neh': 'neh',
  'esth': 'esth',
  'ps': 'ps',
  'prov': 'prov',
  'eccl': 'eccl',
  'song': 'song',
  'isa': 'isa',
  'jer': 'jer',
  'lam': 'lam',
  'ezek': 'ezek',
  'dan': 'dan',
  'hos': 'hos',
  'obad': 'obad',
  'mic': 'mic',
  'nah': 'nah',
  'hab': 'hab',
  'zeph': 'zeph',
  'hag': 'hag',
  'zech': 'zech',
  'mal': 'mal',
  'matt': 'matt',
  'mt': 'matt',
  'mk': 'mark',
  'lk': 'luke',
  'jn': 'john',
  'rom': 'rom',
  '1cor': '1cor',
  '2cor': '2cor',
  'gal': 'gal',
  'eph': 'eph',
  'phil': 'phil',
  'col': 'col',
  '1thess': '1thess',
  '2thess': '2thess',
  '1tim': '1tim',
  '2tim': '2tim',
  'phlm': 'phlm',
  'heb': 'heb',
  '1pet': '1pet',
  '2pet': '2pet',
  '1john': '1john',
  '2john': '2john',
  '3john': '3john',
  'rev': 'rev',
}

export function getBookById(id: string): BibleBook | undefined {
  return BIBLE_BOOKS.find(book => book.id === id)
}

export function getBookByName(name: string): BibleBook | undefined {
  const normalizedName = name.toLowerCase().trim()
  const bookId = BOOK_NAME_MAP[normalizedName]
  if (bookId) {
    return getBookById(bookId)
  }
  return undefined
}

